import Preorder, { PreorderInput } from '../../models/Preorder'
import requestAction from '../../utils/requestAction'

export const upsertPreorder = (preorder: (Preorder|PreorderInput), handleResponse?: (preorder: Preorder) => void) =>
  requestAction('PREORDER_UPSERT')(
    `preorders${preorder.id ? `/${preorder.id}` : ''}`,
    preorder.id ? 'PUT' : 'POST',
    preorder,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.preorder) })

